export default __webpack_public_path__ + "static/media/postcards.85eea3f5.png";